import type * as models from './model'
import type { Resource, ResourceRel } from './resource'
import type { TagType } from './resources/tags'
import type { VersionType } from './resources/versions'



const apiResources = [
	// ##__API_RESOURCE_LIST_START__##
	'addresses',
	'adjustments',
	'adyen_gateways',
	'adyen_payments',
	'applications',
	'attachments',
	'authorizations',
	'avalara_accounts',
	'axerve_gateways',
	'axerve_payments',
	'bing_geocoders',
	'braintree_gateways',
	'braintree_payments',
	'bundles',
	'buy_x_pay_y_promotions',
	'captures',
	'carrier_accounts',
	'checkout_com_gateways',
	'checkout_com_payments',
	'cleanups',
	'coupon_codes_promotion_rules',
	'coupon_recipients',
	'coupons',
	'custom_promotion_rules',
	'customer_addresses',
	'customer_groups',
	'customer_password_resets',
	'customer_payment_sources',
	'customer_subscriptions',
	'customers',
	'delivery_lead_times',
	'discount_engine_items',
	'discount_engines',
	'easypost_pickups',
	'event_callbacks',
	'event_stores',
	'events',
	'exports',
	'external_gateways',
	'external_payments',
	'external_promotions',
	'external_tax_calculators',
	'fixed_amount_promotions',
	'fixed_price_promotions',
	'flex_promotions',
	'free_gift_promotions',
	'free_shipping_promotions',
	'geocoders',
	'gift_card_recipients',
	'gift_cards',
	'google_geocoders',
	'imports',
	'in_stock_subscriptions',
	'inventory_models',
	'inventory_return_locations',
	'inventory_stock_locations',
	'klarna_gateways',
	'klarna_payments',
	'line_item_options',
	'line_items',
	'links',
	'manual_gateways',
	'manual_tax_calculators',
	'markets',
	'merchants',
	'notifications',
	'order_amount_promotion_rules',
	'order_copies',
	'order_factories',
	'order_subscription_items',
	'order_subscriptions',
	'orders',
	'organizations',
	'packages',
	'parcel_line_items',
	'parcels',
	'payment_gateways',
	'payment_methods',
	'payment_options',
	'paypal_gateways',
	'paypal_payments',
	'percentage_discount_promotions',
	'pickups',
	'price_frequency_tiers',
	'price_list_schedulers',
	'price_lists',
	'price_tiers',
	'price_volume_tiers',
	'prices',
	'promotion_rules',
	'promotions',
	'recurring_order_copies',
	'refunds',
	'reserved_stocks',
	'resource_errors',
	'return_line_items',
	'returns',
	'satispay_gateways',
	'satispay_payments',
	'shipments',
	'shipping_categories',
	'shipping_method_tiers',
	'shipping_methods',
	'shipping_weight_tiers',
	'shipping_zones',
	'sku_list_items',
	'sku_list_promotion_rules',
	'sku_lists',
	'sku_options',
	'skus',
	'stock_items',
	'stock_line_items',
	'stock_locations',
	'stock_reservations',
	'stock_transfers',
	'stores',
	'stripe_gateways',
	'stripe_payments',
	'stripe_tax_accounts',
	'subscription_models',
	'tags',
	'talon_one_accounts',
	'tax_calculators',
	'tax_categories',
	'tax_rules',
	'taxjar_accounts',
	'transactions',
	'versions',
	'vertex_accounts',
	'voids',
	'webhooks',
	'wire_transfers'
	// ##__API_RESOURCE_LIST_STOP__##
] as const

export type ResourceTypeLock = typeof apiResources[number]
export const resourceList: readonly ResourceTypeLock[] = apiResources


// Singleton resources
export const singletonList = [
	// ##__API_RESOURCE_SINGLETON_START__##
	'applications',
	'organizations'
	// ##__API_RESOURCE_SINGLETON_STOP__##
] as const


// Retrievable resources
export type RetrievableResourceType = ResourceTypeLock

export type RetrievableResource = Resource & {
	type: RetrievableResourceType
}


// Listable resources
export type ListableResourceType = Exclude<ResourceTypeLock,
	// ##__API_RESOURCE_NOT_LISTABLE_START__##
	'applications'
|	'organizations'
// ##__API_RESOURCE_NOT_LISTABLE_STOP__##
>

export type ListableResource = Resource & {
	type: ListableResourceType
}


// Creatable resources
export const creatableResources = [
	// ##__API_RESOURCE_CREATABLE_START__##
	'addresses',
	'adjustments',
	'adyen_gateways',
	'adyen_payments',
	'attachments',
	'avalara_accounts',
	'axerve_gateways',
	'axerve_payments',
	'bing_geocoders',
	'braintree_gateways',
	'braintree_payments',
	'bundles',
	'buy_x_pay_y_promotions',
	'carrier_accounts',
	'checkout_com_gateways',
	'checkout_com_payments',
	'cleanups',
	'coupon_codes_promotion_rules',
	'coupon_recipients',
	'coupons',
	'custom_promotion_rules',
	'customer_addresses',
	'customer_groups',
	'customer_password_resets',
	'customer_payment_sources',
	'customer_subscriptions',
	'customers',
	'delivery_lead_times',
	'easypost_pickups',
	'exports',
	'external_gateways',
	'external_payments',
	'external_promotions',
	'external_tax_calculators',
	'fixed_amount_promotions',
	'fixed_price_promotions',
	'flex_promotions',
	'free_gift_promotions',
	'free_shipping_promotions',
	'gift_card_recipients',
	'gift_cards',
	'google_geocoders',
	'imports',
	'in_stock_subscriptions',
	'inventory_models',
	'inventory_return_locations',
	'inventory_stock_locations',
	'klarna_gateways',
	'klarna_payments',
	'line_item_options',
	'line_items',
	'links',
	'manual_gateways',
	'manual_tax_calculators',
	'markets',
	'merchants',
	'notifications',
	'order_amount_promotion_rules',
	'order_copies',
	'order_subscription_items',
	'order_subscriptions',
	'orders',
	'packages',
	'parcel_line_items',
	'parcels',
	'payment_methods',
	'payment_options',
	'paypal_gateways',
	'paypal_payments',
	'percentage_discount_promotions',
	'price_frequency_tiers',
	'price_list_schedulers',
	'price_lists',
	'price_volume_tiers',
	'prices',
	'recurring_order_copies',
	'return_line_items',
	'returns',
	'satispay_gateways',
	'satispay_payments',
	'shipments',
	'shipping_categories',
	'shipping_methods',
	'shipping_weight_tiers',
	'shipping_zones',
	'sku_list_items',
	'sku_list_promotion_rules',
	'sku_lists',
	'sku_options',
	'skus',
	'stock_items',
	'stock_line_items',
	'stock_locations',
	'stock_reservations',
	'stock_transfers',
	'stores',
	'stripe_gateways',
	'stripe_payments',
	'stripe_tax_accounts',
	'subscription_models',
	'tags',
	'talon_one_accounts',
	'tax_categories',
	'tax_rules',
	'taxjar_accounts',
	'vertex_accounts',
	'webhooks',
	'wire_transfers'
	// ##__API_RESOURCE_CREATABLE_STOP__##
] as const

export type CreatableResourceType = typeof creatableResources[number]
export type CreatableResource = Resource & {
	type: CreatableResourceType
}


// Updatable resources
export const updatableResources = [
	// ##__API_RESOURCE_UPDATABLE_START__##
	'addresses',
	'adjustments',
	'adyen_gateways',
	'adyen_payments',
	'attachments',
	'authorizations',
	'avalara_accounts',
	'axerve_gateways',
	'axerve_payments',
	'bing_geocoders',
	'braintree_gateways',
	'braintree_payments',
	'bundles',
	'buy_x_pay_y_promotions',
	'captures',
	'carrier_accounts',
	'checkout_com_gateways',
	'checkout_com_payments',
	'cleanups',
	'coupon_codes_promotion_rules',
	'coupon_recipients',
	'coupons',
	'custom_promotion_rules',
	'customer_addresses',
	'customer_groups',
	'customer_password_resets',
	'customer_payment_sources',
	'customer_subscriptions',
	'customers',
	'delivery_lead_times',
	'easypost_pickups',
	'events',
	'exports',
	'external_gateways',
	'external_payments',
	'external_promotions',
	'external_tax_calculators',
	'fixed_amount_promotions',
	'fixed_price_promotions',
	'flex_promotions',
	'free_gift_promotions',
	'free_shipping_promotions',
	'gift_card_recipients',
	'gift_cards',
	'google_geocoders',
	'imports',
	'in_stock_subscriptions',
	'inventory_models',
	'inventory_return_locations',
	'inventory_stock_locations',
	'klarna_gateways',
	'klarna_payments',
	'line_item_options',
	'line_items',
	'links',
	'manual_gateways',
	'manual_tax_calculators',
	'markets',
	'merchants',
	'notifications',
	'order_amount_promotion_rules',
	'order_copies',
	'order_subscription_items',
	'order_subscriptions',
	'orders',
	'packages',
	'parcel_line_items',
	'parcels',
	'payment_methods',
	'payment_options',
	'paypal_gateways',
	'paypal_payments',
	'percentage_discount_promotions',
	'price_frequency_tiers',
	'price_list_schedulers',
	'price_lists',
	'price_volume_tiers',
	'prices',
	'recurring_order_copies',
	'refunds',
	'return_line_items',
	'returns',
	'satispay_gateways',
	'satispay_payments',
	'shipments',
	'shipping_categories',
	'shipping_methods',
	'shipping_weight_tiers',
	'shipping_zones',
	'sku_list_items',
	'sku_list_promotion_rules',
	'sku_lists',
	'sku_options',
	'skus',
	'stock_items',
	'stock_line_items',
	'stock_locations',
	'stock_reservations',
	'stock_transfers',
	'stores',
	'stripe_gateways',
	'stripe_payments',
	'stripe_tax_accounts',
	'subscription_models',
	'tags',
	'talon_one_accounts',
	'tax_categories',
	'tax_rules',
	'taxjar_accounts',
	'vertex_accounts',
	'voids',
	'webhooks',
	'wire_transfers'
	// ##__API_RESOURCE_UPDATABLE_STOP__##
] as const

export type UpdatableResourceType = typeof updatableResources[number]
export type UpdatableResource = Resource & {
	type: UpdatableResourceType
}


// Deletable resources
export const deletableResources = [
	// ##__API_RESOURCE_DELETABLE_START__##
	'addresses',
	'adjustments',
	'adyen_gateways',
	'adyen_payments',
	'attachments',
	'avalara_accounts',
	'axerve_gateways',
	'axerve_payments',
	'bing_geocoders',
	'braintree_gateways',
	'braintree_payments',
	'bundles',
	'buy_x_pay_y_promotions',
	'carrier_accounts',
	'checkout_com_gateways',
	'checkout_com_payments',
	'cleanups',
	'coupon_codes_promotion_rules',
	'coupon_recipients',
	'coupons',
	'custom_promotion_rules',
	'customer_addresses',
	'customer_groups',
	'customer_password_resets',
	'customer_payment_sources',
	'customer_subscriptions',
	'customers',
	'delivery_lead_times',
	'easypost_pickups',
	'exports',
	'external_gateways',
	'external_payments',
	'external_promotions',
	'external_tax_calculators',
	'fixed_amount_promotions',
	'fixed_price_promotions',
	'flex_promotions',
	'free_gift_promotions',
	'free_shipping_promotions',
	'gift_card_recipients',
	'gift_cards',
	'google_geocoders',
	'imports',
	'in_stock_subscriptions',
	'inventory_models',
	'inventory_return_locations',
	'inventory_stock_locations',
	'klarna_gateways',
	'klarna_payments',
	'line_item_options',
	'line_items',
	'links',
	'manual_gateways',
	'manual_tax_calculators',
	'markets',
	'merchants',
	'notifications',
	'order_amount_promotion_rules',
	'order_copies',
	'order_subscription_items',
	'order_subscriptions',
	'orders',
	'packages',
	'parcel_line_items',
	'parcels',
	'payment_methods',
	'payment_options',
	'paypal_gateways',
	'paypal_payments',
	'percentage_discount_promotions',
	'price_frequency_tiers',
	'price_list_schedulers',
	'price_lists',
	'price_volume_tiers',
	'prices',
	'recurring_order_copies',
	'return_line_items',
	'returns',
	'satispay_gateways',
	'satispay_payments',
	'shipments',
	'shipping_categories',
	'shipping_methods',
	'shipping_weight_tiers',
	'shipping_zones',
	'sku_list_items',
	'sku_list_promotion_rules',
	'sku_lists',
	'sku_options',
	'skus',
	'stock_items',
	'stock_line_items',
	'stock_locations',
	'stock_reservations',
	'stock_transfers',
	'stores',
	'stripe_gateways',
	'stripe_payments',
	'stripe_tax_accounts',
	'subscription_models',
	'tags',
	'talon_one_accounts',
	'tax_categories',
	'tax_rules',
	'taxjar_accounts',
	'vertex_accounts',
	'webhooks',
	'wire_transfers'
	// ##__API_RESOURCE_DELETABLE_STOP__##
] as const

export type DeletableResourceType = typeof deletableResources[number]
export type DeletableResource = Resource & {
	type: DeletableResourceType
}


// Taggable resources
export const taggableResources = [
	// ##__API_RESOURCE_TAGGABLE_START__##
	'addresses',
	'bundles',
	'buy_x_pay_y_promotions',
	'coupons',
	'customers',
	'external_promotions',
	'fixed_amount_promotions',
	'fixed_price_promotions',
	'flex_promotions',
	'free_gift_promotions',
	'free_shipping_promotions',
	'gift_cards',
	'line_item_options',
	'line_items',
	'order_subscriptions',
	'orders',
	'percentage_discount_promotions',
	'promotions',
	'returns',
	'shipments',
	'shipping_methods',
	'sku_options',
	'skus'
	// ##__API_RESOURCE_TAGGABLE_STOP__##
] as const

export type TaggableResourceType = typeof taggableResources[number]
export type TaggableResource = Resource & {
	type: TaggableResourceType,
	tags?: Array<ResourceRel & { type: TagType }> | null
}


// Versionable resources
export const versionableResources = [
	// ##__API_RESOURCE_VERSIONABLE_START__##
	'addresses',
	'adjustments',
	'adyen_gateways',
	'adyen_payments',
	'authorizations',
	'avalara_accounts',
	'axerve_gateways',
	'axerve_payments',
	'braintree_gateways',
	'braintree_payments',
	'bundles',
	'buy_x_pay_y_promotions',
	'captures',
	'carrier_accounts',
	'checkout_com_gateways',
	'checkout_com_payments',
	'cleanups',
	'coupon_codes_promotion_rules',
	'coupon_recipients',
	'coupons',
	'custom_promotion_rules',
	'customer_addresses',
	'customer_groups',
	'customer_payment_sources',
	'customer_subscriptions',
	'delivery_lead_times',
	'discount_engines',
	'exports',
	'external_gateways',
	'external_payments',
	'external_promotions',
	'external_tax_calculators',
	'fixed_amount_promotions',
	'fixed_price_promotions',
	'flex_promotions',
	'free_gift_promotions',
	'free_shipping_promotions',
	'gift_card_recipients',
	'gift_cards',
	'in_stock_subscriptions',
	'inventory_models',
	'inventory_return_locations',
	'inventory_stock_locations',
	'klarna_gateways',
	'klarna_payments',
	'manual_gateways',
	'manual_tax_calculators',
	'markets',
	'merchants',
	'order_amount_promotion_rules',
	'order_subscriptions',
	'orders',
	'packages',
	'parcel_line_items',
	'parcels',
	'payment_gateways',
	'payment_methods',
	'paypal_gateways',
	'paypal_payments',
	'percentage_discount_promotions',
	'price_frequency_tiers',
	'price_list_schedulers',
	'price_lists',
	'price_tiers',
	'price_volume_tiers',
	'prices',
	'promotion_rules',
	'promotions',
	'refunds',
	'reserved_stocks',
	'returns',
	'satispay_gateways',
	'satispay_payments',
	'shipments',
	'shipping_categories',
	'shipping_method_tiers',
	'shipping_methods',
	'shipping_weight_tiers',
	'shipping_zones',
	'sku_list_items',
	'sku_list_promotion_rules',
	'sku_lists',
	'sku_options',
	'skus',
	'stock_items',
	'stock_line_items',
	'stock_locations',
	'stock_transfers',
	'stores',
	'stripe_gateways',
	'stripe_payments',
	'stripe_tax_accounts',
	'talon_one_accounts',
	'tax_calculators',
	'tax_categories',
	'tax_rules',
	'taxjar_accounts',
	'transactions',
	'vertex_accounts',
	'voids',
	'webhooks',
	'wire_transfers'
	// ##__API_RESOURCE_VERSIONABLE_STOP__##
] as const

export type VersionableResourceType = typeof versionableResources[number]
export type VersionableResource = Resource & {
	type: VersionableResourceType,
	versions?: Array<ResourceRel & { type: VersionType }> | null
}



// Utility functions
export function getResources(sort?: boolean): readonly ResourceTypeLock[] {
	return sort? [ ...resourceList ].sort() : resourceList
}

export function getSingletons(sort?: boolean): readonly string[] {
	return sort? [ ...singletonList ].sort() : singletonList
}

export function isSingleton(resource: ResourceTypeLock): boolean {
	return (singletonList as readonly ResourceTypeLock[]).includes(resource)
}

export function isCreatable(resource: ResourceTypeLock): boolean {
	return (creatableResources as readonly ResourceTypeLock[]).includes(resource)
}

export function isUpdatable(resource: ResourceTypeLock): boolean {
	return (updatableResources as readonly ResourceTypeLock[]).includes(resource)
}

export function isDeletable(resource: ResourceTypeLock): boolean {
	return (deletableResources as readonly ResourceTypeLock[]).includes(resource)
}

export function isTaggable(resource: ResourceTypeLock): boolean {
	return (taggableResources as readonly ResourceTypeLock[]).includes(resource)
}

export function isVersionable(resource: ResourceTypeLock): boolean {
	return (versionableResources as readonly ResourceTypeLock[]).includes(resource)
}



// Helper types
export type ResourceFields = {
	// ##__API_RESOURCE_FIELDS_START__##
	addresses: models.Address,
	adjustments: models.Adjustment,
	adyen_gateways: models.AdyenGateway,
	adyen_payments: models.AdyenPayment,
	applications: models.Application,
	attachments: models.Attachment,
	authorizations: models.Authorization,
	avalara_accounts: models.AvalaraAccount,
	axerve_gateways: models.AxerveGateway,
	axerve_payments: models.AxervePayment,
	bing_geocoders: models.BingGeocoder,
	braintree_gateways: models.BraintreeGateway,
	braintree_payments: models.BraintreePayment,
	bundles: models.Bundle,
	buy_x_pay_y_promotions: models.BuyXPayYPromotion,
	captures: models.Capture,
	carrier_accounts: models.CarrierAccount,
	checkout_com_gateways: models.CheckoutComGateway,
	checkout_com_payments: models.CheckoutComPayment,
	cleanups: models.Cleanup,
	coupon_codes_promotion_rules: models.CouponCodesPromotionRule,
	coupon_recipients: models.CouponRecipient,
	coupons: models.Coupon,
	custom_promotion_rules: models.CustomPromotionRule,
	customer_addresses: models.CustomerAddress,
	customer_groups: models.CustomerGroup,
	customer_password_resets: models.CustomerPasswordReset,
	customer_payment_sources: models.CustomerPaymentSource,
	customer_subscriptions: models.CustomerSubscription,
	customers: models.Customer,
	delivery_lead_times: models.DeliveryLeadTime,
	discount_engine_items: models.DiscountEngineItem,
	discount_engines: models.DiscountEngine,
	easypost_pickups: models.EasypostPickup,
	event_callbacks: models.EventCallback,
	event_stores: models.EventStore,
	events: models.Event,
	exports: models.Export,
	external_gateways: models.ExternalGateway,
	external_payments: models.ExternalPayment,
	external_promotions: models.ExternalPromotion,
	external_tax_calculators: models.ExternalTaxCalculator,
	fixed_amount_promotions: models.FixedAmountPromotion,
	fixed_price_promotions: models.FixedPricePromotion,
	flex_promotions: models.FlexPromotion,
	free_gift_promotions: models.FreeGiftPromotion,
	free_shipping_promotions: models.FreeShippingPromotion,
	geocoders: models.Geocoder,
	gift_card_recipients: models.GiftCardRecipient,
	gift_cards: models.GiftCard,
	google_geocoders: models.GoogleGeocoder,
	imports: models.Import,
	in_stock_subscriptions: models.InStockSubscription,
	inventory_models: models.InventoryModel,
	inventory_return_locations: models.InventoryReturnLocation,
	inventory_stock_locations: models.InventoryStockLocation,
	klarna_gateways: models.KlarnaGateway,
	klarna_payments: models.KlarnaPayment,
	line_item_options: models.LineItemOption,
	line_items: models.LineItem,
	links: models.Link,
	manual_gateways: models.ManualGateway,
	manual_tax_calculators: models.ManualTaxCalculator,
	markets: models.Market,
	merchants: models.Merchant,
	notifications: models.Notification,
	order_amount_promotion_rules: models.OrderAmountPromotionRule,
	order_copies: models.OrderCopy,
	order_factories: models.OrderFactory,
	order_subscription_items: models.OrderSubscriptionItem,
	order_subscriptions: models.OrderSubscription,
	orders: models.Order,
	organizations: models.Organization,
	packages: models.Package,
	parcel_line_items: models.ParcelLineItem,
	parcels: models.Parcel,
	payment_gateways: models.PaymentGateway,
	payment_methods: models.PaymentMethod,
	payment_options: models.PaymentOption,
	paypal_gateways: models.PaypalGateway,
	paypal_payments: models.PaypalPayment,
	percentage_discount_promotions: models.PercentageDiscountPromotion,
	pickups: models.Pickup,
	price_frequency_tiers: models.PriceFrequencyTier,
	price_list_schedulers: models.PriceListScheduler,
	price_lists: models.PriceList,
	price_tiers: models.PriceTier,
	price_volume_tiers: models.PriceVolumeTier,
	prices: models.Price,
	promotion_rules: models.PromotionRule,
	promotions: models.Promotion,
	recurring_order_copies: models.RecurringOrderCopy,
	refunds: models.Refund,
	reserved_stocks: models.ReservedStock,
	resource_errors: models.ResourceError,
	return_line_items: models.ReturnLineItem,
	returns: models.Return,
	satispay_gateways: models.SatispayGateway,
	satispay_payments: models.SatispayPayment,
	shipments: models.Shipment,
	shipping_categories: models.ShippingCategory,
	shipping_method_tiers: models.ShippingMethodTier,
	shipping_methods: models.ShippingMethod,
	shipping_weight_tiers: models.ShippingWeightTier,
	shipping_zones: models.ShippingZone,
	sku_list_items: models.SkuListItem,
	sku_list_promotion_rules: models.SkuListPromotionRule,
	sku_lists: models.SkuList,
	sku_options: models.SkuOption,
	skus: models.Sku,
	stock_items: models.StockItem,
	stock_line_items: models.StockLineItem,
	stock_locations: models.StockLocation,
	stock_reservations: models.StockReservation,
	stock_transfers: models.StockTransfer,
	stores: models.Store,
	stripe_gateways: models.StripeGateway,
	stripe_payments: models.StripePayment,
	stripe_tax_accounts: models.StripeTaxAccount,
	subscription_models: models.SubscriptionModel,
	tags: models.Tag,
	talon_one_accounts: models.TalonOneAccount,
	tax_calculators: models.TaxCalculator,
	tax_categories: models.TaxCategory,
	tax_rules: models.TaxRule,
	taxjar_accounts: models.TaxjarAccount,
	transactions: models.Transaction,
	versions: models.Version,
	vertex_accounts: models.VertexAccount,
	voids: models.Void,
	webhooks: models.Webhook,
	wire_transfers: models.WireTransfer
	// ##__API_RESOURCE_FIELDS_STOP__##
}


export type ResourceSortFields = {
	// ##__API_RESOURCE_SORTABLE_FIELDS_START__##
	addresses: models.AddressSort,
	adjustments: models.AdjustmentSort,
	adyen_gateways: models.AdyenGatewaySort,
	adyen_payments: models.AdyenPaymentSort,
	applications: models.ApplicationSort,
	attachments: models.AttachmentSort,
	authorizations: models.AuthorizationSort,
	avalara_accounts: models.AvalaraAccountSort,
	axerve_gateways: models.AxerveGatewaySort,
	axerve_payments: models.AxervePaymentSort,
	bing_geocoders: models.BingGeocoderSort,
	braintree_gateways: models.BraintreeGatewaySort,
	braintree_payments: models.BraintreePaymentSort,
	bundles: models.BundleSort,
	buy_x_pay_y_promotions: models.BuyXPayYPromotionSort,
	captures: models.CaptureSort,
	carrier_accounts: models.CarrierAccountSort,
	checkout_com_gateways: models.CheckoutComGatewaySort,
	checkout_com_payments: models.CheckoutComPaymentSort,
	cleanups: models.CleanupSort,
	coupon_codes_promotion_rules: models.CouponCodesPromotionRuleSort,
	coupon_recipients: models.CouponRecipientSort,
	coupons: models.CouponSort,
	custom_promotion_rules: models.CustomPromotionRuleSort,
	customer_addresses: models.CustomerAddressSort,
	customer_groups: models.CustomerGroupSort,
	customer_password_resets: models.CustomerPasswordResetSort,
	customer_payment_sources: models.CustomerPaymentSourceSort,
	customer_subscriptions: models.CustomerSubscriptionSort,
	customers: models.CustomerSort,
	delivery_lead_times: models.DeliveryLeadTimeSort,
	discount_engine_items: models.DiscountEngineItemSort,
	discount_engines: models.DiscountEngineSort,
	easypost_pickups: models.EasypostPickupSort,
	event_callbacks: models.EventCallbackSort,
	event_stores: models.EventStoreSort,
	events: models.EventSort,
	exports: models.ExportSort,
	external_gateways: models.ExternalGatewaySort,
	external_payments: models.ExternalPaymentSort,
	external_promotions: models.ExternalPromotionSort,
	external_tax_calculators: models.ExternalTaxCalculatorSort,
	fixed_amount_promotions: models.FixedAmountPromotionSort,
	fixed_price_promotions: models.FixedPricePromotionSort,
	flex_promotions: models.FlexPromotionSort,
	free_gift_promotions: models.FreeGiftPromotionSort,
	free_shipping_promotions: models.FreeShippingPromotionSort,
	geocoders: models.GeocoderSort,
	gift_card_recipients: models.GiftCardRecipientSort,
	gift_cards: models.GiftCardSort,
	google_geocoders: models.GoogleGeocoderSort,
	imports: models.ImportSort,
	in_stock_subscriptions: models.InStockSubscriptionSort,
	inventory_models: models.InventoryModelSort,
	inventory_return_locations: models.InventoryReturnLocationSort,
	inventory_stock_locations: models.InventoryStockLocationSort,
	klarna_gateways: models.KlarnaGatewaySort,
	klarna_payments: models.KlarnaPaymentSort,
	line_item_options: models.LineItemOptionSort,
	line_items: models.LineItemSort,
	links: models.LinkSort,
	manual_gateways: models.ManualGatewaySort,
	manual_tax_calculators: models.ManualTaxCalculatorSort,
	markets: models.MarketSort,
	merchants: models.MerchantSort,
	notifications: models.NotificationSort,
	order_amount_promotion_rules: models.OrderAmountPromotionRuleSort,
	order_copies: models.OrderCopySort,
	order_factories: models.OrderFactorySort,
	order_subscription_items: models.OrderSubscriptionItemSort,
	order_subscriptions: models.OrderSubscriptionSort,
	orders: models.OrderSort,
	organizations: models.OrganizationSort,
	packages: models.PackageSort,
	parcel_line_items: models.ParcelLineItemSort,
	parcels: models.ParcelSort,
	payment_gateways: models.PaymentGatewaySort,
	payment_methods: models.PaymentMethodSort,
	payment_options: models.PaymentOptionSort,
	paypal_gateways: models.PaypalGatewaySort,
	paypal_payments: models.PaypalPaymentSort,
	percentage_discount_promotions: models.PercentageDiscountPromotionSort,
	pickups: models.PickupSort,
	price_frequency_tiers: models.PriceFrequencyTierSort,
	price_list_schedulers: models.PriceListSchedulerSort,
	price_lists: models.PriceListSort,
	price_tiers: models.PriceTierSort,
	price_volume_tiers: models.PriceVolumeTierSort,
	prices: models.PriceSort,
	promotion_rules: models.PromotionRuleSort,
	promotions: models.PromotionSort,
	recurring_order_copies: models.RecurringOrderCopySort,
	refunds: models.RefundSort,
	reserved_stocks: models.ReservedStockSort,
	resource_errors: models.ResourceErrorSort,
	return_line_items: models.ReturnLineItemSort,
	returns: models.ReturnSort,
	satispay_gateways: models.SatispayGatewaySort,
	satispay_payments: models.SatispayPaymentSort,
	shipments: models.ShipmentSort,
	shipping_categories: models.ShippingCategorySort,
	shipping_method_tiers: models.ShippingMethodTierSort,
	shipping_methods: models.ShippingMethodSort,
	shipping_weight_tiers: models.ShippingWeightTierSort,
	shipping_zones: models.ShippingZoneSort,
	sku_list_items: models.SkuListItemSort,
	sku_list_promotion_rules: models.SkuListPromotionRuleSort,
	sku_lists: models.SkuListSort,
	sku_options: models.SkuOptionSort,
	skus: models.SkuSort,
	stock_items: models.StockItemSort,
	stock_line_items: models.StockLineItemSort,
	stock_locations: models.StockLocationSort,
	stock_reservations: models.StockReservationSort,
	stock_transfers: models.StockTransferSort,
	stores: models.StoreSort,
	stripe_gateways: models.StripeGatewaySort,
	stripe_payments: models.StripePaymentSort,
	stripe_tax_accounts: models.StripeTaxAccountSort,
	subscription_models: models.SubscriptionModelSort,
	tags: models.TagSort,
	talon_one_accounts: models.TalonOneAccountSort,
	tax_calculators: models.TaxCalculatorSort,
	tax_categories: models.TaxCategorySort,
	tax_rules: models.TaxRuleSort,
	taxjar_accounts: models.TaxjarAccountSort,
	transactions: models.TransactionSort,
	versions: models.VersionSort,
	vertex_accounts: models.VertexAccountSort,
	voids: models.VoidSort,
	webhooks: models.WebhookSort,
	wire_transfers: models.WireTransferSort
	// ##__API_RESOURCE_SORTABLE_FIELDS_STOP__##
}
